import { createElement } from 'inferno-create-element';
import { PageHeader, SectionHeading, DemoBox, CodeBlock, PropTable } from '../_helpers';
import {
  Menubar, MenubarMenu, MenubarTrigger, MenubarContent,
  MenubarItem, MenubarSeparator, MenubarShortcut,
} from '@/ui/Menubar';

export function MenubarPage() {
  return createElement('div', { className: 'space-y-10' },
    createElement(PageHeader, {
      title: 'Menubar',
      description: 'A visually persistent menu common in desktop applications that provides quick access to a consistent set of commands.',
    }),

    // Demo
    createElement(SectionHeading, { id: 'demo' }, 'Demo'),
    createElement(DemoBox, null,
      createElement(Menubar, null,
        createElement(MenubarMenu, null,
          createElement(MenubarTrigger, null, 'File'),
          createElement(MenubarContent, null,
            createElement(MenubarItem, null,
              'New Tab',
              createElement(MenubarShortcut, null, '\u2318T'),
            ),
            createElement(MenubarItem, null,
              'New Window',
              createElement(MenubarShortcut, null, '\u2318N'),
            ),
            createElement(MenubarSeparator, null),
            createElement(MenubarItem, null, 'Share'),
            createElement(MenubarSeparator, null),
            createElement(MenubarItem, null,
              'Print',
              createElement(MenubarShortcut, null, '\u2318P'),
            ),
          ),
        ),
        createElement(MenubarMenu, null,
          createElement(MenubarTrigger, null, 'Edit'),
          createElement(MenubarContent, null,
            createElement(MenubarItem, null,
              'Undo',
              createElement(MenubarShortcut, null, '\u2318Z'),
            ),
            createElement(MenubarItem, null,
              'Redo',
              createElement(MenubarShortcut, null, '\u21E7\u2318Z'),
            ),
            createElement(MenubarSeparator, null),
            createElement(MenubarItem, null,
              'Cut',
              createElement(MenubarShortcut, null, '\u2318X'),
            ),
            createElement(MenubarItem, null,
              'Copy',
              createElement(MenubarShortcut, null, '\u2318C'),
            ),
            createElement(MenubarItem, null,
              'Paste',
              createElement(MenubarShortcut, null, '\u2318V'),
            ),
          ),
        ),
        createElement(MenubarMenu, null,
          createElement(MenubarTrigger, null, 'View'),
          createElement(MenubarContent, null,
            createElement(MenubarItem, null, 'Always Show Bookmarks Bar'),
            createElement(MenubarItem, null, 'Always Show Full URLs'),
            createElement(MenubarSeparator, null),
            createElement(MenubarItem, null,
              'Reload',
              createElement(MenubarShortcut, null, '\u2318R'),
            ),
            createElement(MenubarItem, null,
              'Toggle Fullscreen',
              createElement(MenubarShortcut, null, 'F11'),
            ),
          ),
        ),
      ),
    ),

    // Usage
    createElement(SectionHeading, { id: 'usage' }, 'Usage'),
    createElement(CodeBlock, { code: `import {
  Menubar, MenubarMenu, MenubarTrigger, MenubarContent,
  MenubarItem, MenubarSeparator, MenubarShortcut,
} from '@/ui/Menubar'

createElement(Menubar, null,
  createElement(MenubarMenu, null,
    createElement(MenubarTrigger, null, 'File'),
    createElement(MenubarContent, null,
      createElement(MenubarItem, null, 'New Tab'),
      createElement(MenubarSeparator, null),
      createElement(MenubarItem, null, 'Print'),
    ),
  ),
)` }),

    // Props
    createElement(SectionHeading, { id: 'props' }, 'Props'),
    createElement('h3', { className: 'text-sm font-semibold mb-2' }, 'MenubarItem'),
    createElement(PropTable, {
      rows: [
        { prop: 'disabled', type: 'boolean', default: 'false' },
        { prop: 'onClick', type: '(e: Event) => void', default: '\u2014' },
      ],
    }),
  );
}
